import { useSignal } from '@preact/signals-react'

import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'

const NewOrganizationForm = function ({ isResellerSelected = false, adminEmailErrorSignal, emailMatchErrorSignal, validatedSignal, validateAdminEmail }) {

	const adminEmailSignal = useSignal('')
	const verifyEmailSignal = useSignal('')

	const handleAdminEmailChange = (event) => {
		const value = event.target.value
		adminEmailSignal.value = value
		adminEmailErrorSignal.value = null
		if (verifyEmailSignal.value) {
			emailMatchErrorSignal.value = verifyEmailSignal.value !== value ? 'The email entered does not match.' : null
		}
	}

	const handleAdminEmailBlur = async () => {
		if (!adminEmailSignal.value) return
		try {
			const result = await validateAdminEmail(adminEmailSignal.value)
			adminEmailErrorSignal.value = result ? null : 'This email address is not available.'
		} catch (error) {
			adminEmailErrorSignal.value = error.message || 'Failed to validate email address.'
		}
	}

	const handleVerifyEmailChange = (event) => {
		const value = event.target.value
		verifyEmailSignal.value = value
		emailMatchErrorSignal.value = value !== adminEmailSignal.value ? 'The email entered does not match.' : null
	}

	return (
		<>
			<Row className="mb-3">
				<Form.Group as={Col}>
					<Form.Label htmlFor="organizationName">Name</Form.Label>
					<Form.Control id="organizationName" name="name" maxLength="50" required />
					<Form.Control.Feedback type="invalid">Name is required.</Form.Control.Feedback>
				</Form.Group>
			</Row>
			<p className="mb-3">
				Please enter an email address to create an administrator for this {
					isResellerSelected ? 'reseller' : 'organization'
				}.
			</p>
			<Row className="mb-3">
				<Form.Group as={Col}>
					<Form.Label htmlFor="administratorEmail">Admin Email</Form.Label>
					<Form.Control
						id="administratorEmail"
						name="administratorEmail"
						type="email"
						required
						maxLength="200"
						onChange={handleAdminEmailChange}
						onBlur={handleAdminEmailBlur}
						isInvalid={validatedSignal.value && !!adminEmailErrorSignal.value}
					/>
					<Form.Control.Feedback type="invalid">
						{adminEmailErrorSignal.value || 'Please enter a valid email address.'}
					</Form.Control.Feedback>
				</Form.Group>
			</Row>
			<Row className="mb-3">
				<Form.Group as={Col}>
					<Form.Label htmlFor="verifiedAdministratorEmail">Verify Email</Form.Label>
					<Form.Control
						id="verifiedAdministratorEmail"
						type="email"
						required
						maxLength="200"
						onChange={handleVerifyEmailChange}
						isInvalid={validatedSignal.value && !!emailMatchErrorSignal.value}
					/>
					<Form.Control.Feedback type="invalid">
						{emailMatchErrorSignal.value || 'Please verify the email address.'}
					</Form.Control.Feedback>
				</Form.Group>
			</Row>
		</>
	)
}
export default NewOrganizationForm
